import { DateApiResponse } from '../state/infiniteCalendarSeries';
import { _getEventCalendarDatesUrl, type DatesApiParams } from './constants';

export const getEventCalendarDates = async ({
    env,
    eventId,
    month,
    year,
    tzIdentifier,
}: DatesApiParams) => {
    try {
        const response = await fetch(
            _getEventCalendarDatesUrl({
                env,
                eventId,
                month,
                year,
                tzIdentifier,
            }),
            {
                method: 'GET',
                credentials: 'include',
            },
        );

        const body = await response.json();
        if (body.error) {
            throw new Error(
                `Checkout Fairy returned a body describing an error: ${body.error} (full body: ${body})`,
            );
        }

        return body as DateApiResponse;
    } catch (error) {
        console.log('error', error);
        throw new Error(`Checkout Fairy returned an error: ${error.message}`);
    }
};
